import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WebWidget = _resolveComponent("WebWidget")!

  return (_ctx.mode === 'full')
    ? (_openBlock(), _createBlock(_component_WebWidget, {
        key: 0,
        title: _ctx.title2,
        "contact-title": _ctx.contactTitle,
        "campaign-id": _ctx.campaignId,
        class: "WidgetComponent"
      }, null, 8, ["title", "contact-title", "campaign-id"]))
    : _createCommentVNode("", true)
}